<div class="mt-1">
  <p-accordion>
    <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">
      <form [formGroup]="searchForm">
        <div class="grid">
          <div class="col-12">
            <div class="p-fluid formgrid grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.ReferenceKey' | translate }}</label>
                  <p-chips
                    formControlName="referenceKeys"
                    [(ngModel)]="searchParams.referenceKeys"
                    separator=","
                    (onAdd)="chipsAdd($event, 'referenceKeys')"
                  ></p-chips>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.Forwarder'  | translate }}</label>
                <p-multiSelect
                  formControlName="customsForwarders"
                  [options]="forwarderOptions"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [filter]="true"
                  filterBy="label"
                ></p-multiSelect>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.DeliveryType' | translate }}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                [options]="deliveryTypeOptions" [showClear]="true"
                formControlName="deliveryType">
              </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.CarTrip' | translate }}</label>
                  <p-chips
                    formControlName="carTrips"
                    [(ngModel)]="searchParams.carTrips"
                    separator=","
                    (onAdd)="chipsAdd($event, 'carTrips')"
                  ></p-chips>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.ConsolidationNo' | translate }}</label>
                  <p-chips
                    formControlName="consolidationNos"
                    separator=","
                    (onAdd)="chipsAdd($event, 'consolidationNos')"
                    [(ngModel)]="searchParams.consolidationNos"
                  ></p-chips>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.Facility' | translate }}</label>
                  <laas-facility-dropdown
                    formControlName="facilityList"
                    [isMultiple]="true"
                    [showFilter]="true"
                    [showToggleAll]="true">
                  </laas-facility-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label for="formCountry">{{ 'ImportCrossBoundryDialog.SearchForm.FromCountry' | translate}}</label>
                <p-dropdown
                  inputId="formCountry"
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="countryOptions"
                  [showClear]="true"
                  (onChange)="onCountryChange($event, 'from')"
                  formControlName="fromCountry">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.FromCity' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="fromCityOptions" [showClear]="true"
                  (onChange)="onCountryChange($event, 'from')"
                  formControlName="fromCity">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.FromArea' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="fromAreaOptions" [showClear]="true"
                  formControlName="fromArea">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label for="toCountry">{{ 'ImportCrossBoundryDialog.SearchForm.ToCountry' | translate}}</label>
                <p-dropdown
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="countryOptions"
                  [showClear]="true"
                  (onChange)="onCountryChange($event, 'to')"
                  formControlName="toCountry">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.ToCity' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="toCityOptions" [showClear]="true"
                  (onChange)="onCountryChange($event, 'to')"
                  formControlName="toCity">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.ToArea' | translate}}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="toAreaOptions" [showClear]="true"
                  formControlName="toArea">
                </p-dropdown>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3 laas-calendar">
                <laas-calendar
                  #createDt
                  [title]="'ImportCrossBoundryDialog.SearchForm.BookingWarehousingCreateDt'"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event)"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'ImportCrossBoundryDialog.SearchForm.HasCrossBoundry' | translate}}</label>
                <p-dropdown placeholder="{{ 'Common.DropDown.Select' | translate}}"
                  [options]="hasCrossBoundryOptions" [showClear]="true"
                  formControlName="hasCrossBoundry">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="inline-block mb-1">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}"
              (click)="searchBtnClick()"></button>
            </div><div class="inline-block mb-1">
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-2"
                (click)="resetBtnClick($event)"></button>
            </div>
          </div>
        </div>
      </form>
    </p-accordionTab>
  </p-accordion>
  <div class="mt-2">
    <laas-data-table
      #headerTable
      [dataKey]="'rowNumber'"
      [defaultColumns]="columns"
      [loading]="isLoading"
      [value]="searchResults"
      [selectable]="true"
      [lazy]="true"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      [(selectedRows)]="selectedRows"
      [isShowCreateRowFunction]="false"
    >
    <!-- Button -->
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'forwarder'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping : forwarderOptions
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCountry'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromArea'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCountry'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toArea'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType" class="overflow-text">
                <ng-container *ngSwitchDefault>
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>


    </laas-data-table>
  </div>
  <div class="mt-2 text-center">
    <button pButton pRipple
      [disabled]="selectedRows.length == 0"
      label="{{ 'TruckCostAllocation.Button.CreateDialog' | translate }}"
      (click)="importCbBtnLCick($event)"></button>
  </div>

  <p-dialog header="{{ 'TruckCostAllocation.Button.CreateDialog' | translate }}" appendTo="body" [(visible)]="isShowCreateDialog" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: '70%', height: '65%' } " >
    <laas-create-cross-boundry laas-create-cross-boundry *ngIf="isShowCreateDialog" (dialogClosed)="resetBtnClick($event)" [bookingReferenceKeys]="bookingReferenceKeys"  [warehousingReferenceKeys]="warehousingReferenceKeys"  (closeCreateCrossBoundryEvent)="closeCreateCrossBoundryEvent($event)"></laas-create-cross-boundry>
  </p-dialog>
</div>
s
